import { API_BASE } from "../../../consts";
import authService from "../../../services/AuthService";

const api = (path, opts) => authService.authenticatedFetch(`${API_BASE}${path}`, opts);
const jsonOrThrow = async (resp) => {
    const data = await resp.json().catch(() => ({}));
    if (!resp.ok) {
        const err = new Error(data.message || data.error || `Request failed: ${resp.status}`);
        err.status = resp.status;
        err.detail = data.detail;
        throw err;
    }
    return data;
};

export const getInboundShortages = (status = "CLOSED", minDays = 10, maxDays = 50) => {
    const params = new URLSearchParams({ status, min_days: minDays, max_days: maxDays });
    return api(`/api/reimbursements/inbound-shortages?${params}`).then(jsonOrThrow);
};
export const getOverdueShipments = (graceDays = 3) => api(`/api/reimbursements/overdue?grace_days=${graceDays}`).then(jsonOrThrow);

export const listReimbursementCases = (status) =>
    api(`/api/reimbursements/cases${status ? `?status=${status}` : ""}`).then(jsonOrThrow);

export const createReimbursementCase = (payload) =>
    api("/api/reimbursements/cases", {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload),
    }).then(jsonOrThrow);

export const updateReimbursementCase = (caseId, updates) =>
    api(`/api/reimbursements/cases/${caseId}`, {
        method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify(updates),
    }).then(jsonOrThrow);

export const deleteReimbursementCase = (caseId) =>
    api(`/api/reimbursements/cases/${caseId}`, { method: "DELETE" }).then(jsonOrThrow);

export const enrichReimbursementLink = (wfsShipmentSplitId, sku) =>
    api("/api/reimbursements/enrich-link", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ wfs_shipment_split_id: wfsShipmentSplitId, sku }),
    }).then(jsonOrThrow);